import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useOutsideEvent } from "@cadenza/ui-hooks";
import { useRADActions } from "./useRADActions.js";

export const useRADSelector = () => {
  const { getCleanRADs } = useRADActions();
  const navigate = useNavigate();

  const radRef = useRef(null);
  const [dropdown, setDropdown] = useState(false);
  useOutsideEvent(radRef, dropdown, () => setDropdown(false));

  const toggleDropdown = () => {
    setDropdown((prevState) => !prevState);
  };

  const handleNavigation = (id) => {
    navigate(`/rad/${id}`);
  };

  const rads = getCleanRADs();

  return {
    radRef,
    dropdown,
    toggleDropdown,
    handleNavigation,
    rads,
  };
};
